export default __webpack_public_path__ + "static/media/close.f94f4878.svg";